import { fmtDateTimeWIB } from "./util";

export const STATUS_META = {
    DRAFT: { label: "Draf", cls: "bg-neutral-100 text-neutral-600" },
    SUBMITTED: { label: "Terkirim", cls: "bg-sage/15 text-sage-dark" },
    APPROVED: { label: "Disetujui · Terkunci", cls: "bg-ink text-white" },
    REOPENED: { label: "Dibuka ulang", cls: "bg-amber-50 text-amber-700" },
};
const TIMING = { ON_TIME: "Tepat waktu", LATE: "Terlambat", NOT_REQUIRED: "Tidak wajib" };

export function StatusPill({ status, testId }) {
    const m = STATUS_META[status] || STATUS_META.SUBMITTED;
    return <span className={`inline-block px-2 py-0.5 rounded-full text-[10px] uppercase tracking-widest whitespace-nowrap ${m.cls}`} data-testid={testId}>{m.label}</span>;
}

export default function StatusBanner({ report }) {
    const r = report;
    return (
        <div className="border border-mist bg-white/70 rounded-sm p-3 text-xs text-neutral-600 space-y-1" data-testid="report-status-banner">
            <div className="flex flex-wrap items-center gap-2">
                <StatusPill status={r.status} testId="report-status-pill" />
                {r.first_submitted_at && (
                    <span>Pertama dikirim {fmtDateTimeWIB(r.first_submitted_at)} · <b data-testid="report-timing">{TIMING[r.submission_timing] || r.submission_timing}</b> · Revisi {r.version}</span>
                )}
                {r.status === "DRAFT" && <span>Draf disimpan {fmtDateTimeWIB(r.draft_saved_at)} — belum dikirim</span>}
            </div>
            {r.status === "SUBMITTED" && <div>Laporan ini masih bisa dikoreksi sampai Owner menyetujuinya.</div>}
            {r.status === "REOPENED" && <div className="text-amber-800" data-testid="reopen-reason">Dibuka ulang oleh Owner: “{r.reopen_reason}”. Simpan koreksi untuk mengirim ulang.</div>}
            {r.status === "APPROVED" && r.approval && <div>Disetujui oleh {r.approval.approved_by_name} · {fmtDateTimeWIB(r.approval.approved_at)} (revisi {r.approval.approved_revision})</div>}
        </div>
    );
}
